/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-05-29 22:31:41
 * @LastEditTime: 2021-11-12 21:38:13
 * @LastEditors: Please set LastEditors
 */
//const apiURL = 'http://xkxy.local'
//const apiURL  = '//xkxyapi.yjf531.cn'
const apiURL  = '//baoming-date.medmeet.com.cn'

export { apiURL }



// WEBPACK FOOTER //
// ./src/config/service.js